$(function () {
    const checkBg = function () {
        $('[data-second-bg]').each(function () {
            const $this = $(this);
            var $target = $this.find($this.data('second-bg') + ':visible');
            if ($target.length) {
                if ($target.length) {
                    var $secondBg = $this.find('.second-bg');
                    if (!$secondBg.length) {
                        $this.prepend('<div class="second-bg" />');
                        $this.addClass('has-second-bg');
                        $secondBg = $this.find('.second-bg');
                    }
                    $secondBg.css({ top: ($target.offset().top - $this.offset().top) + 'px' });
                }
            } else {
                $this.find('.second-bg').remove();
                $this.removeClass('has-second-bg');
            }
        });
    };
    $(window).on('resize', function () {
        checkBg();
    });
    $(window).on('scroll', function () {
        checkBg();
    });
    checkBg();
});
